import React from 'react';
import {BorderLineContainer} from "./borderLineStyles";

function BorderLine(props) {
    return (
        <BorderLineContainer/>
    );
}

export default BorderLine;